import { object, number, string } from "yup";

export const PerformanceBonusTypeSchema = object({
  numberOfOrders: number().required("Задолжително"),
  amount: number().required("Задолжително"),
  cityFk: number().required("Задолжително"),
});
